export var createNumericInputDriver = function (wrapper) {
    var base = wrapper.$('.numeric-input');
    var numericInput = base.$('input');
    return {
        getValue: function () { return numericInput.value().then(function (num) { return parseInt(num, 10); }); },
        enterValue: function (value) { return numericInput.enterValue(value.toString()); },
        isDisabled: function () { return numericInput.attr('disabled').then(function (disabled) { return !!disabled; }); },
        isSmall: function () { return base.hasClass('small'); },
        clickIncrement: function () { return base.$('.increment').click(); },
        clickDecrement: function () { return base.$('.decrement').click(); },
        incrementButtonDisabled: function () { return base.$('.increment').hasClass('max'); },
        decrementButtonDisabled: function () { return base.$('.decrement').hasClass('min'); },
        base: base
    };
};
//# sourceMappingURL=numeric-input.driver.js.map